import { lazy } from 'react';
import Loadable from 'components/Loadable';

const CourseManagement = Loadable(lazy(() => import('./components/course-management/CourseManagement')));
const MyCourses = Loadable(lazy(() => import('./components/my-courses/MyCourses')));

export const courseRoutes = {
  path: 'courses',
  children: [
    { index: true, element: <CourseManagement initialTab="dashboard" /> },
    { path: 'dashboard', element: <CourseManagement initialTab="dashboard" /> },
    { path: 'master', element: <CourseManagement initialTab="master" /> },
    { path: 'assignments', element: <CourseManagement initialTab="assignments" /> },
    { path: 'certificate-approvals', element: <CourseManagement initialTab="approvals" /> },
    { path: 'training-sessions', element: <CourseManagement initialTab="sessions" /> },
    { path: 'reports', element: <CourseManagement initialTab="reports" /> },
    { path: 'my-courses', element: <MyCourses /> }
  ]
};

export default courseRoutes;
